import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {MODAL_VIEW_STATE} from "../utils/enums";
import utils from "../utils";
import toast from "../utils/toast";

const slice = createSlice({
    name: 'offCode',
    initialState: {
        modalViewState: MODAL_VIEW_STATE.NOT_LOADING,
    }, reducers: {
        setModalViewState: (state, action) => {
            state.modalViewState = action.payload
        },

        onError: (state, action) => {
            state.modalViewState = MODAL_VIEW_STATE.NOT_LOADING
            toast.error(action.payload);
        },
    },
});

export default slice.reducer

const {setModalViewState, onError} = slice.actions


export const checkOffCode = (code, classId, courseId, courseCategoryId, teacherId, amount,onSuccess,t) =>
    async dispatch => {
        try {
            dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
            const {data} =await api.offCode.checkOffCode(code, classId, courseId, courseCategoryId, teacherId, amount)
            dispatch(setModalViewState(MODAL_VIEW_STATE.NOT_LOADING))
            onSuccess(data?.data)
        } catch (e) {
            const message = e.response?.data?.message ?? t("errorInConnection")
            dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
        }
    }